import Axios from 'axios';

const axiosInstance = Axios.create({
  withCredentials: false,
  responseType: 'json',
});

export { axiosInstance };
